import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FlashOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31.59.551c.421.233.63.722.505 1.187l-3.241 12.125a1.048 1.048 0 0 1-2.025-.541l2.156-8.065-13.218 14.19a1.048 1.048 0 0 1-1.534-1.429L30.316.754A1.048 1.048 0 0 1 31.59.55ZM29.38 25.704c.423.394.447 1.057.052 1.48L13.685 44.087a1.048 1.048 0 0 1-1.78-.985l3.159-11.79a1.048 1.048 0 0 1 2.024.543l-2.07 7.727 12.88-13.825a1.048 1.048 0 0 1 1.482-.052ZM37.991 17.52a1.048 1.048 0 1 0-.739-1.96L6.01 27.32a1.048 1.048 0 1 0 .739 1.961L37.99 17.52Z"
  }));
});
FlashOff.displayName = 'FlashOff';
FlashOff.defaultProps = {
  'aria-label': 'FlashOff'
};
export default FlashOff;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FlashOff.js
// module id = 3165
// module chunks = 11